import { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import './CSS/ShopCategory.css';
import Item from '../Components/Item/Item';
import men_banner from '../Components/Assets/banner_mens.png';
import women_banner from '../Components/Assets/banner_women.png';
import kids_banner from '../Components/Assets/banner_kids.png';
import th_banner from '../Components/Assets/th_banner.png';
import { Circles } from 'react-loader-spinner';

const ShopCategory = () => {
  const { main, sub } = useParams();

  const [products, setProducts] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [sortOption, setSortOption] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);

  const ITEMS_PER_PAGE = 12;

  const bannerMap = {
    férfi: men_banner,
    női: women_banner,
    gyerek: kids_banner,
    kiegészítők: th_banner,
    men: men_banner,
    women: women_banner,
    kid: kids_banner,
  };
  const banner = bannerMap[main?.toLowerCase()] || men_banner;

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        setLoading(true);
        const query = new URLSearchParams({
          main: main || '',
          sub: sub || '',
          search: searchQuery,
          sort: sortOption,
          page: currentPage,
          limit: ITEMS_PER_PAGE,
        }).toString();

        const res = await fetch(`/api/products?${query}`);
        const data = await res.json();
        setProducts(data.products);
        setTotalPages(data.totalPages);
      } catch (error) {
        console.error('Termékek betöltése hiba:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, [main, sub, searchQuery, sortOption, currentPage]);

  return (
    <div className='shop-category'>
      <img className='shopcategory-banner' src={banner} alt={`${main} kategória`} />
      <input
        type='text'
        className='shopcategory-search'
        placeholder='Keresés terméknévre...'
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
      />

      <div className='shopcategory-indexSort'>
        <p>
          <span>
            {products.length > 0
              ? `Megjelenik ${(currentPage - 1) * ITEMS_PER_PAGE + 1}-${(currentPage - 1) * ITEMS_PER_PAGE + products.length}`
              : 'Nincs megjeleníthető termék'}
          </span>
        </p>
        <div className='shopcategory-sort'>
          <select
            className='sort-dropdown'
            value={sortOption}
            onChange={(e) => setSortOption(e.target.value)}
          >
            <option value=''>Rendezés</option>
            <option value='priceLowHigh'>Ár szerint növekvő</option>
            <option value='priceHighLow'>Ár szerint csökkenő</option>
            <option value='AZ'>Név (A-Z)</option>
            <option value='ZA'>Név (Z-A)</option>
          </select>
        </div>
      </div>

      {loading ? (
        <div className='loader-container'>
          <Circles height='80' width='80' color='#4fa94d' ariaLabel='circles-loading' visible={true} />
        </div>
      ) : (
        <div className='shopcategory-products'>
          {products.map((item) => (
            <Item
              key={item.id}
              id={item.id}
              name={item.name}
              image={item.image}
              price={item.price}
            />
          ))}
        </div>
      )}

      {totalPages > 1 && (
        <div className='pagination'>
          {Array.from({ length: totalPages }, (_, index) => (
            <button
              key={index + 1}
              className={currentPage === index + 1 ? 'active' : ''}
              onClick={() => setCurrentPage(index + 1)}
            >
              {index + 1}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default ShopCategory;
